import { observable } from 'mobx';

export type UserForwardedEmailResponseArgs = {
  id: number;
  email: string;
};

export type UserForwardedEmailArgs = {
  id?: number;
  email?: string;
};

export const convertUserForwardedEmailResponseToArgs = (response: UserForwardedEmailResponseArgs) => {
  const args: UserForwardedEmailArgs = {
    id: response.id,
    email: response.email
  };
  return args;
};

export default class UserForwardedEmail {
  @observable id?: number;
  @observable email?: string;

  constructor(args: UserForwardedEmailArgs) {
    this.id = args.id;
    this.email = args.email;
  }

  get params() {
    return {
      id: this.id,
      email: this.email
    };
  }
}
